module.exports = __webpack_public_path__ + "static/rcc-os-fa-graph-mobile-578d0b60d94ccb01eceda234a63c185c.png";